import { useTablistContext } from './tablist-context';
import { useTextDirectionality } from '../../theme/text-directionality-provider';

export const useTabElementIsInView = () => {
  const { tabListWrapper, scrollBackButton, scrollForwardButton } =
    useTablistContext();

  const tabScrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center',
  };

  const dir = useTextDirectionality();

  const elementIsInView = (tabElement: React.RefObject<HTMLElement>) => {
    if (!tabListWrapper || !tabElement.current) {
      return false;
    }

    const leftEdge = tabListWrapper.getBoundingClientRect();
    const scrollButtonWidth =
      (scrollBackButton || scrollForwardButton)?.getBoundingClientRect()
        .width || 0;

    const leftOffset =
      leftEdge.left + (scrollBackButton ? scrollButtonWidth : 0);
    const rightOffset =
      leftEdge.right - (scrollForwardButton ? scrollButtonWidth : 0);

    const { left, right } = tabElement.current.getBoundingClientRect();

    if (dir === 'rtl') {
      return right <= rightOffset && left >= leftEdge.left;
    }
    return left >= leftOffset && right <= rightOffset;
  };

  return {
    elementIsInView,
    tabScrollOptions,
  };
};
